export const REQUEST_SUSPEND_USER = "REQUEST_SUSPEND_USER";
export const ERROR_SUSPEND_USER = "ERROR_SUSPEND_USER";
export const SET_SUSPEND_USER = "SET_SUSPEND_USER";

export const SET_MESSAGE_NULL = "SET_MESSAGE_NULL";
export const REQUEST_MESSAGE_NULL = "REQUEST_MESSAGE_NULL";

export const REQUEST_UNSUSPEND_USER = "REQUEST_UNSUSPEND_USER";
export const ERROR_UNSUSPEND_USER = "ERROR_UNSUSPEND_USER";
